module.exports = __webpack_public_path__ + "static/media/play.c65f6a86.svg";